/** Page /mariage-halal-ville-davray — landing GEO/SEO discrète. */

export const MARIAGE_HALAL_CONTENT = {
  fr: {
    meta: {
      title: "Mariage halal à Ville-d'Avray (92)",
      description:
        "Salle de mariage halal privatisée à Ville-d'Avray, entre Boulogne, Sèvres et Versailles : viande halal certifiée, vin d'honneur sans alcool, de 12 à 100 invités assis.",
      keywords:
        "mariage halal Ville d'Avray, salle mariage halal 92, traiteur halal Hauts-de-Seine, mariage halal Boulogne, mariage halal Versailles, réception halal sans alcool",
    },
    breadcrumb: [
      { label: "Accueil", to: "/" },
      { label: "Événements", to: "/evenements" },
      { label: "Mariage", to: "/mariage" },
      { label: "Mariage halal" },
    ],
    overline: "Mariage halal · Hauts-de-Seine (92)",
    h1: "Mariage halal à Ville-d'Avray, dans un hôtel particulier privatisé",
    intro:
      "Un hôtel particulier du XIXe siècle, une terrasse de 240 m² sur un parc arboré, et une cuisine qui travaille avec de la viande halal certifiée achetée chez notre boucher partenaire : L'Entracte accueille votre mariage halal de 12 à 100 invités assis, à 15 minutes de Paris, Boulogne-Billancourt et Versailles.",
    ctaDevis: "Demander un devis mariage halal",
    ctaCall: "Appeler le 01 82 00 18 67",
    heroAlt: "Table de mariage dressée à L'Entracte, hôtel particulier à Ville-d'Avray",

    brief: {
      title: "Votre mariage halal en bref",
      caption: "Informations clés pour un mariage halal à L'Entracte",
      rows: [
        ["Lieu", "Hôtel particulier privatisé, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Viande", "Viande halal certifiée, achetée chez notre boucher partenaire"],
        ["Menus", "Aucune préparation à base de porc dans votre menu, cuisson sans alcool"],
        ["Vin d'honneur", "Formule sans alcool : cocktails sans alcool et jus premium"],
        ["Boissons apportées", "Vos boissons halal sont acceptées pour la réception"],
        ["Capacité", "De 12 à 100 invités assis, jusqu'à 130 en cocktail"],
        ["Espaces", "Grand Salon, Petit Salon et terrasse de 240 m² sur parc"],
        ["Durée", "3 heures incluses, prolongeable jusqu'à minuit (400 € par heure)"],
        ["Accès", "15 minutes de Paris, Boulogne-Billancourt et Versailles · stationnement à proximité immédiate"],
      ],
    },

    engagements: {
      title: "Ce que nous vous garantissons",
      items: [
        {
          label: "Une viande halal certifiée.",
          body: " Toutes les viandes de votre menu sont achetées halal chez notre boucher partenaire, et préparées dans nos cuisines par notre chef.",
        },
        {
          label: "Aucune préparation à base de porc.",
          body: " Votre menu est construit sans porc ni charcuterie, et les cuissons se font sans alcool.",
        },
        {
          label: "Un vin d'honneur sans alcool.",
          body: " Cocktails sans alcool, jus de fruits premium et pièces cocktail préparées par le chef remplacent le champagne.",
        },
        {
          label: "Vos boissons acceptées.",
          body: " Pour une réception halal, vous pouvez apporter vos boissons ; nous les mettons au frais et assurons le service.",
        },
        {
          label: "Un lieu entièrement à vous.",
          body: " À partir de 50 invités, la privatisation totale vous réserve les deux salons et la terrasse.",
        },
        {
          label: "Une organisation sur mesure.",
          body: " Arrivée séparée des invités, espace à l'écart, agencement des salons : dites-nous vos besoins dans la demande de devis, nous adaptons la mise en place.",
        },
      ],
    },

    menu: {
      title: "Des menus halal préparés sur place",
      intro:
        "Notre cuisine, traditionnelle et créative, est entièrement faite maison à partir de produits frais. Le chef compose votre menu de mariage halal avec vous, en 3 ou 4 services :",
      groups: [
        {
          label: "Entrées",
          body:
            "tartare de Saint-Jacques et guacamole d'avocat, coulis de fruits rouges ; saumon gravlax mariné 24 h au sel de Guérande et au poivre de Sichuan ; trio de ravioles Saint-Jacques, cabillaud et crevette, sauce crustacés ; œuf nuage, crème forestière aux morilles ; ballottine de légumes, sauce gingembre-miel (végétarien).",
        },
        {
          label: "Plats",
          body:
            "filet de bar juste snacké, tian de légumes de saison ; duo de saumon et cabillaud, sauce beurre blanc ; volaille fermière halal, gratin de légumes et sauce champignons ; viande halal de votre choix, garniture de saison ; risotto crémeux aux champignons et gambas (sans alcool).",
        },
        {
          label: "Desserts",
          body:
            "Saint-Honoré « comme une pièce montée » ; pavlova à l'orange ; tarte Tatin du chef ; macaron poire-caramel ; cœur fondant au chocolat.",
        },
      ],
      note:
        "Menus végétariens, végétaliens et sans gluten également possibles. Menu enfant (plat et dessert) à 40 €.",
      ctaMenu: "Voir la carte du restaurant",
      alt: "Plat préparé par le chef de L'Entracte pour une réception",
    },

    capacityTable: {
      title: "Quel espace pour combien d'invités ?",
      caption: "Espace privatisé selon le nombre d'invités adultes",
      head: ["Nombre d'invités adultes", "Espace privatisé"],
      rows: [
        ["De 12 à 29", "Le Petit Salon"],
        ["De 30 à 49", "Le Grand Salon"],
        ["50 et plus (avec cocktail apéritif)", "L'établissement entier"],
      ],
    },

    process: {
      title: "Comment organiser votre réception",
      steps: [
        "Vous nous indiquez votre date, votre nombre d'invités et vos exigences (viande halal, sans alcool, organisation particulière). Nous répondons généralement sous 24 heures.",
        "Nous visitons le lieu ensemble et construisons votre menu avec le chef.",
        "Vous validez le devis avec un acompte de 50 % ; la date est bloquée.",
        "Dix jours avant, vous confirmez le nombre de convives, les menus et votre heure d'arrivée.",
        "Le jour J, notre équipe coordonne le service du vin d'honneur au dernier café.",
      ],
    },

    zone: {
      title: "Un lieu de mariage halal dans l'Ouest parisien",
      intro:
        "L'Entracte est au 3 rue de Versailles, 92410 Ville-d'Avray, entre Saint-Cloud et Versailles. Nous recevons régulièrement des familles venues de tout l'Ouest parisien :",
      items: [
        "Boulogne-Billancourt, Issy-les-Moulineaux et Sèvres : 10 à 15 minutes.",
        "Saint-Cloud, Garches, Vaucresson et Marnes-la-Coquette : moins de 10 minutes.",
        "Versailles, Chaville et Viroflay : 15 minutes.",
        "Paris (Porte de Saint-Cloud, 15e, 16e) : 15 à 20 minutes en voiture.",
        "En train : gare de Sèvres – Ville-d'Avray à 1 km, lignes L (Paris Saint-Lazare, La Défense) et U (La Défense).",
        "Stationnement à proximité immédiate du restaurant, accès aux personnes à mobilité réduite.",
      ],
    },

    faqTitle: "Questions fréquentes sur les mariages halal",
    faq: [
      {
        question: "La viande servie est-elle halal ?",
        answer:
          "Oui. Les viandes de votre menu sont achetées halal certifiées chez notre boucher partenaire, puis préparées dans nos cuisines par notre chef.",
      },
      {
        question: "Y a-t-il du porc dans les menus de réception ?",
        answer:
          "Votre menu est construit sans porc ni charcuterie, et les cuissons se font sans alcool. La carte du restaurant, elle, reste une carte traditionnelle française.",
      },
      {
        question: "Proposez-vous un vin d'honneur sans alcool ?",
        answer:
          "Oui : cocktails sans alcool, jus de fruits premium et 5 pièces cocktail par personne préparées par le chef, servis sur la terrasse ou dans les salons.",
      },
      {
        question: "Peut-on apporter nos propres boissons ?",
        answer:
          "Pour une réception halal, oui : vous pouvez apporter vos boissons, nous les mettons au frais et assurons le service. À préciser dans le devis.",
      },
      {
        question: "Combien d'invités peut-on recevoir ?",
        answer:
          "De 12 à 100 invités assis, et jusqu'à 130 en cocktail en privatisation totale. Le Grand Salon reçoit de 30 à 65 invités assis et la terrasse jusqu'à 90.",
      },
      {
        question: "Quel budget prévoir ?",
        answer:
          "Nos réceptions de mariage démarrent à partir de 99 € TTC par invité, repas, boissons incluses au menu, service et privatisation de l'espace compris. Le menu enfant est à 40 €.",
      },
      {
        question: "Peut-on prévoir une organisation particulière ?",
        answer:
          "Oui : arrivée séparée des invités, espace à l'écart, agencement des salons, horaires adaptés. Indiquez vos besoins dans votre demande de devis et nous adaptons la mise en place.",
      },
      {
        question: "Jusqu'à quelle heure peut durer la réception ?",
        answer:
          "La prestation comprend 3 heures (déjeuner 12h30-15h30 ou dîner 19h30-22h30). Vous pouvez prolonger jusqu'à minuit, à 400 € par heure supplémentaire.",
      },
      {
        question: "Où se situe la salle par rapport à Boulogne et Versailles ?",
        answer:
          "L'Entracte est à Ville-d'Avray (92), à 10-15 minutes de Boulogne-Billancourt et de Sèvres, à 15 minutes de Versailles et de Paris, avec un stationnement à proximité immédiate.",
      },
    ],

    devis: {
      title: "Parlons de votre mariage halal",
      body:
        "Indiquez-nous votre date, le nombre d'invités et vos exigences : nous revenons vers vous sous 24 heures avec une proposition détaillée, et nous vous proposons une visite du lieu.",
      contact: "Téléphone : 01 82 00 18 67 · E-mail : restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Aller plus loin",
      links: [
        { to: "/mariage", label: "Toutes nos formules mariage" },
        { to: "/evenements", label: "Réceptions privées & privatisation" },
        { to: "/galerie", label: "La galerie photos" },
      ],
    },

    eventType: "Mariage",
  },

  en: {
    meta: {
      title: "Halal wedding venue in Ville-d'Avray (92)",
      description:
        "Private halal wedding venue in Ville-d'Avray, between Boulogne, Sèvres and Versailles: certified halal meat, alcohol-free reception drinks, 12 to 100 seated guests.",
      keywords:
        "halal wedding Ville d'Avray, halal wedding venue 92, halal catering Hauts-de-Seine, halal wedding Boulogne, halal wedding Versailles",
    },
    breadcrumb: [
      { label: "Home", to: "/" },
      { label: "Events", to: "/evenements" },
      { label: "Wedding", to: "/mariage" },
      { label: "Halal wedding" },
    ],
    overline: "Halal wedding · Hauts-de-Seine (92)",
    h1: "Halal weddings in Ville-d'Avray, in a private townhouse",
    intro:
      "A 19th-century private townhouse, a 240 m² terrace overlooking a wooded park, and a kitchen that works with certified halal meat bought from our partner butcher: L'Entracte hosts your halal wedding for 12 to 100 seated guests, 15 minutes from Paris, Boulogne-Billancourt and Versailles.",
    ctaDevis: "Request a halal wedding quote",
    ctaCall: "Call +33 1 82 00 18 67",
    heroAlt: "Wedding table set at L'Entracte, a private townhouse in Ville-d'Avray",

    brief: {
      title: "Your halal wedding at a glance",
      caption: "Key information for a halal wedding at L'Entracte",
      rows: [
        ["Venue", "Private townhouse, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Meat", "Certified halal meat, bought from our partner butcher"],
        ["Menus", "No pork in your menu, cooking without alcohol"],
        ["Reception drinks", "Alcohol-free option: mocktails and premium juices"],
        ["Your own drinks", "Your halal drinks are welcome for the reception"],
        ["Capacity", "12 to 100 seated guests, up to 130 for a cocktail reception"],
        ["Spaces", "Grand Salon, Petit Salon and a 240 m² terrace over the park"],
        ["Duration", "3 hours included, extendable until midnight (€400 per hour)"],
        ["Getting here", "15 minutes from Paris, Boulogne-Billancourt and Versailles · parking nearby"],
      ],
    },

    engagements: {
      title: "What we guarantee",
      items: [
        { label: "Certified halal meat.", body: " All the meat in your menu is bought halal from our partner butcher and prepared in our kitchen by our chef." },
        { label: "No pork at all.", body: " Your menu is built without pork or charcuterie, and cooking is done without alcohol." },
        { label: "Alcohol-free reception drinks.", body: " Mocktails, premium fruit juices and the chef's canapés replace champagne." },
        { label: "Your own drinks accepted.", body: " For a halal reception you may bring your own drinks; we chill them and serve them." },
        { label: "A venue entirely yours.", body: " From 50 guests, full hire reserves both lounges and the terrace for you." },
        { label: "Tailored arrangements.", body: " Separate arrival of guests, a quiet area, room layout: tell us in your quote request and we adapt the set-up." },
      ],
    },

    menu: {
      title: "Halal menus prepared on site",
      intro:
        "Our traditional and creative cuisine is made entirely in-house from fresh produce. The chef creates your halal wedding menu with you, in 3 or 4 courses:",
      groups: [
        { label: "Starters", body: "scallop tartare with avocado guacamole; gravlax salmon marinated for 24 hours; trio of ravioli with scallop, cod and prawn; cloud egg with morel cream; vegetable ballotine with ginger and honey (vegetarian)." },
        { label: "Main courses", body: "seared sea bass fillet with seasonal vegetable tian; duo of salmon and cod, beurre blanc sauce; halal farm poultry, vegetable gratin and mushroom sauce; halal meat of your choice with seasonal garnish; creamy mushroom and prawn risotto (alcohol-free)." },
        { label: "Desserts", body: "Saint-Honoré served \"like a wedding cake\"; orange pavlova; the chef's tarte Tatin; pear-caramel macaron; molten chocolate cake." },
      ],
      note: "Vegetarian, plant-based and gluten-free menus also available. Children's menu (main course and dessert) at €40.",
      ctaMenu: "See the restaurant menu",
      alt: "Dish prepared by the chef of L'Entracte for a reception",
    },

    capacityTable: {
      title: "Which space for how many guests?",
      caption: "Private space according to the number of adult guests",
      head: ["Number of adult guests", "Space hired"],
      rows: [
        ["12 to 29", "The Petit Salon"],
        ["30 to 49", "The Grand Salon"],
        ["50 and more (with welcome cocktail)", "The entire venue"],
      ],
    },

    process: {
      title: "How to plan your reception",
      steps: [
        "You tell us your date, your number of guests and your requirements (halal meat, alcohol-free, special arrangements). We usually reply within 24 hours.",
        "We visit the venue together and build your menu with the chef.",
        "You approve the quote with a 50% deposit; the date is secured.",
        "Ten days before, you confirm the number of guests, the menus and your arrival time.",
        "On the day, our team coordinates the service from the welcome drinks to the last coffee.",
      ],
    },

    zone: {
      title: "A halal wedding venue in western Paris",
      intro:
        "L'Entracte is at 3 rue de Versailles, 92410 Ville-d'Avray, between Saint-Cloud and Versailles. We regularly welcome families from across western Paris:",
      items: [
        "Boulogne-Billancourt, Issy-les-Moulineaux and Sèvres: 10 to 15 minutes.",
        "Saint-Cloud, Garches, Vaucresson and Marnes-la-Coquette: under 10 minutes.",
        "Versailles, Chaville and Viroflay: 15 minutes.",
        "Paris (Porte de Saint-Cloud, 15th, 16th): 15 to 20 minutes by car.",
        "By train: Sèvres – Ville-d'Avray station 1 km away, lines L (Paris Saint-Lazare, La Défense) and U (La Défense).",
        "Parking in the immediate vicinity, access for guests with reduced mobility.",
      ],
    },

    faqTitle: "Frequently asked questions about halal weddings",
    faq: [
      { question: "Is the meat you serve halal?", answer: "Yes. The meat in your menu is bought certified halal from our partner butcher, then prepared in our kitchen by our chef." },
      { question: "Is there any pork in the reception menus?", answer: "Your menu is built without pork or charcuterie, and cooking is done without alcohol. The à la carte restaurant menu remains a traditional French menu." },
      { question: "Do you offer alcohol-free reception drinks?", answer: "Yes: mocktails, premium fruit juices and 5 canapés per person prepared by the chef, served on the terrace or in the lounges." },
      { question: "Can we bring our own drinks?", answer: "For a halal reception, yes: you may bring your own drinks, we chill them and serve them. To be set out in the quote." },
      { question: "How many guests can you host?", answer: "From 12 to 100 seated guests, and up to 130 for a cocktail reception with full venue hire. The Grand Salon seats 30 to 65 and the terrace up to 90." },
      { question: "What budget should we plan for?", answer: "Our wedding receptions start from €99 incl. VAT per guest, including the meal, the drinks in the menu, service and private hire of the space. The children's menu is €40." },
      { question: "Can you accommodate special arrangements?", answer: "Yes: separate arrival of guests, a quiet area, room layout, adapted timings. Mention your needs in your quote request and we adapt the set-up." },
      { question: "How late can the reception run?", answer: "The package includes 3 hours (lunch 12.30-3.30pm or dinner 7.30-10.30pm). You can extend until midnight at €400 per additional hour." },
      { question: "Where is the venue compared with Boulogne and Versailles?", answer: "L'Entracte is in Ville-d'Avray (92), 10-15 minutes from Boulogne-Billancourt and Sèvres, 15 minutes from Versailles and Paris, with parking nearby." },
    ],

    devis: {
      title: "Let's talk about your halal wedding",
      body:
        "Tell us your date, the number of guests and your requirements: we get back to you within 24 hours with a detailed proposal and invite you to visit the venue.",
      contact: "Phone: +33 1 82 00 18 67 · Email: restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Go further",
      links: [
        { to: "/mariage", label: "All our wedding packages" },
        { to: "/evenements", label: "Private receptions & venue hire" },
        { to: "/galerie", label: "Photo gallery" },
      ],
    },

    eventType: "Wedding",
  },
};
